<template>
  <fragment>
    <c-button-link
      theme="primary"
      :icon="icon"
      data-toggle="tooltip"
      :title="tooltipTitle"
      @click="copy"><slot></slot></c-button-link>
  </fragment>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: ''
    },
    tooltipTitle: {
      type: String,
      default: 'Copy to Clipboard'
    },
    icon: {
      type: String,
      default: 'fa-copy'
    }
  },
  methods: {
    async copy() {
      const valueToCopy = this.text ?? '';

      try {
        if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
          await navigator.clipboard.writeText(valueToCopy);
          notifier.success('Success', 'Copied to clipboard');
          return;
        }

        const $temp = $('<textarea readonly></textarea>');

        $temp.css({
          position: 'fixed',
          top: 0,
          left: 0,
          width: '1px',
          height: '1px',
          padding: 0,
          border: 'none',
          outline: 'none',
          boxShadow: 'none',
          background: 'transparent',
          opacity: 0
        });

        $('body').append($temp);
        $temp.val(valueToCopy);

        const el = $temp[0];
        el.focus();
        el.select();
        el.setSelectionRange(0, valueToCopy.length);

        const ok = document.execCommand('copy');
        $temp.remove();

        if (!ok) {
          throw new Error('document.execCommand("copy") returned false');
        }

        notifier.success('Success', 'Copied to clipboard');
      } catch (e) {
        notifier.error('Error', 'Failed to copy to clipboard');
      }
    }
  }
}
</script>
